import React from "react";
import "./style.scss";
import {getProjects} from "../../store/projects";
import {Project} from "./project";
import {ProjectNavigation} from "./projectNavigation";
import {Swipeable} from "react-swipeable";
import AnimatedBackground from "./AnimatedBackground";

interface State {
    openElement: number;
    activeElement: number;
    autoAdvancing: boolean;
}

interface Props {}

export type ClickEvent = "open"|"close"|"click";

const AUTO_INTERVAL_MS  = 4000;
const AUTO_INITIAL_MS   = 2000;
const AUTO_TRANSITION_MS = 1000;

export class Projects extends React.Component<Props, State> {

    state: State;
    private autoInterval: ReturnType<typeof setInterval>  | null = null;
    private autoTimeout:  ReturnType<typeof setTimeout>   | null = null;
    private autoClassTimeout: ReturnType<typeof setTimeout> | null = null;

    constructor(props: Props) {
        super(props);
        this.state = {
            openElement: -1,
            activeElement: 0,
            autoAdvancing: false,
        };
        this.handleClickEvent = this.handleClickEvent.bind(this);
        this.handleSwipeEvent = this.handleSwipeEvent.bind(this);
    }

    componentDidMount() {
        this.scheduleAutoAdvance(AUTO_INITIAL_MS);
    }

    componentWillUnmount() {
        this.clearAutoAdvance();
    }

    private scheduleAutoAdvance(delayMs: number) {
        this.clearAutoAdvance();
        this.autoTimeout = setTimeout(() => {
            this.startAutoAdvance();
        }, delayMs);
    }

    private startAutoAdvance() {
        this.autoInterval = setInterval(() => {
            if (this.state.openElement !== -1) return;
            const max = getProjects().length - 1;
            this.setState(prev => ({
                activeElement: prev.activeElement === max ? 0 : prev.activeElement + 1,
                autoAdvancing: true,
            }));
            if (this.autoClassTimeout) clearTimeout(this.autoClassTimeout);
            this.autoClassTimeout = setTimeout(
                () => this.setState({ autoAdvancing: false }),
                AUTO_TRANSITION_MS
            );
        }, AUTO_INTERVAL_MS);
    }

    private clearAutoAdvance() {
        if (this.autoInterval)     { clearInterval(this.autoInterval);     this.autoInterval = null; }
        if (this.autoTimeout)      { clearTimeout(this.autoTimeout);       this.autoTimeout = null; }
        if (this.autoClassTimeout) { clearTimeout(this.autoClassTimeout);  this.autoClassTimeout = null; }
    }

    handleOpenEvent(i: number, open: boolean) {
        this.setState({ openElement: open ? i : -1 });
    }

    handleClickEvent(e: ClickEvent, i: number) {
        if (this.state.activeElement !== i) {
            return () => {
                this.setState({ openElement: -1, activeElement: i });
                this.scheduleAutoAdvance(AUTO_INITIAL_MS);
            };
        }
        switch (e) {
            case "open":  return () => this.handleOpenEvent(i, true);
            case "close": return () => this.handleOpenEvent(i, false);
            case "click": return () => {};
        }
    }

    handleSwipeEvent(direction: "left" | "right") {
        const max = getProjects().length - 1;
        const active = this.state.activeElement;
        this.scheduleAutoAdvance(AUTO_INITIAL_MS);
        switch (direction) {
            case "left":
                this.setState({
                    openElement: -1,
                    activeElement: active === max ? 0 : active + 1,
                });
                break;
            case "right":
                this.setState({
                    openElement: -1,
                    activeElement: active !== 0 ? active - 1 : max,
                });
                break;
        }
    }

    render(): React.ReactElement {
        const projects = getProjects();
        const wrapperTransform = {
            transform: `translateX(-${this.state.activeElement * (100 / projects.length)}%)`
        };

        return (
        <div className="projects"  id="projects">
            <AnimatedBackground />
            <Swipeable
                onSwipedLeft={() => this.handleSwipeEvent("left")}
                onSwipedRight={() => this.handleSwipeEvent("right")}>
            <div className="projectDiv">
            <div className="contentWrapper">
                <h1>Research & Projects</h1>
                <div className="projectsWindow">
                    <div
                        className={`projectsWrapper${this.state.autoAdvancing ? ' auto' : ''}`}
                        style={wrapperTransform}
                    >
                        {projects.map((project, i) => {
                            console.log(i)
                            return (
                                <Project project={project} open={i === this.state.openElement} onClick={
                                    (event:ClickEvent) => this.handleClickEvent(event, i)} active={i === this.state.activeElement} key={i}/>
                            );
                        })}
                    </div>
                </div>
                <ProjectNavigation projects={projects} active={this.state.activeElement} onClick={this.handleClickEvent} />
            </div>
            </div>
            </Swipeable>
        </div>);
    }
}
